import React from "react";

export default function ECLRichTextDataViz() {
   return <p>Data visualizations currently disabled in Rich Text</p>;
}
